export default __webpack_public_path__ + "images/6464ae2c3dd0368f750756cdc69e8d31.svg";